export const useSmartBannerPosition = () => {
    const hasSmartbanner = document.documentElement.classList.contains("has-smartbanner");
    const hasNotification = document.body.classList.contains("has-notification");
    const smartBannerHeight = hasSmartbanner ? 84 : 0;
    const notificationHeight = hasNotification ? 64 : 0;

    return {
        hasSmartbanner,
        hasNotification,
        smartBannerHeight,
        notificationHeight,
    };
};
